import { createContext, useContext, useState } from 'react';
import { FullScreenLoader } from './FullScreenLoader';

type FullScreenLoaderContextType = {
  isLoading?: boolean;
  showLoader: (timeout?: number) => void;
  hideLoader: () => void;
};

export const FullScreenLoaderContext = createContext(
  {} as FullScreenLoaderContextType,
);

export const FullScreenLoaderProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const showLoader = (timeout: number = 2000) => {
    setIsLoading(true);
    timeout !== Infinity &&
      setTimeout(() => {
        setIsLoading(false);
      }, timeout);
  };

  const hideLoader = () => {
    setIsLoading(false);
  };

  return (
    <FullScreenLoaderContext.Provider
      value={{ isLoading, showLoader, hideLoader }}
    >
      {isLoading && <FullScreenLoader />}
      {children}
    </FullScreenLoaderContext.Provider>
  );
};

export const useFullScreenLoaderContext = () => {
  const context = useContext(FullScreenLoaderContext);
  if (context === undefined) {
    throw new Error(
      'useFullScreenLoaderContext must be used within PrivateRoutes',
    );
  }
  return context;
};
